import {Fragment} from 'react';
import {useParams} from 'react-router';
import {useCustomPage} from '@common/custom-page/use-custom-page';
import {CustomPageBody} from '@common/custom-page/custom-page-body';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {PageStatus} from '@common/http/page-status';
import {SitePageLayout} from '@app/site-page-layout';

/**
 * CUSTOM(albaniantheatre): the foundation CustomPageLayout renders its own
 * Navbar on the "custom-page-navbar" menu position, so the header visibly
 * changed (different logo, no Plays/People links, no search) whenever a footer
 * link such as Privacy Policy was clicked. This renders the same page body
 * inside the site layout so the header and footer stay put.
 */
interface Props {
  slug?: string | number;
}
export function SiteCustomPage({slug}: Props) {
  const {pageSlug} = useParams();
  const query = useCustomPage(slug || pageSlug!);

  return (
    <Fragment>
      <PageMetaTags query={query} />
      <SitePageLayout>
        {query.data ? (
          <CustomPageBody page={query.data.page} />
        ) : (
          <PageStatus query={query} loaderClassName="mt-80" />
        )}
      </SitePageLayout>
    </Fragment>
  );
}
